<template>
    <section class="nav">
        <div class="promo-div">
            <div class="promo-box">
                <div class="text-block-775"><span class="text-span-181">LIMITED TIME: </span>COMPLIMENTARY DOCTOR REVIEW FOR
                    MEDS <strong>OVER $200</strong></div>
            </div>
        </div>
        <div class="nav-holder-div">
            <div class="nav-bar-div w-clearfix">
                <a href="#" class="brand w-nav-brand"><img sizes="84.03125px" srcset="@/assets/images/NewSelf_Logo-p-500.png 500w, @/assets/images/NewSelf_Logo-p-800.png 800w, @/assets/images/NewSelf_Logo.png 1000w" alt="" src="@/assets/images/NewSelf_Logo.png" loading="lazy" class="image-389"></a>
                <div class="div-block-1714 addtopmargin">
                    <a href="/login?page_ref=productPage" title="Log in to your account" class="link-block-51 w-inline-block" v-if="!isLoggedin"></a>
                    <a href="#" class="link-block-68 w-inline-block" title="Log out" @click.prevent="logoutUser"  v-else>
                      <img src="@/assets/images/power.svg" loading="lazy" alt="" class="image-422">&nbsp;&nbsp;
                    </a>
                    <a href="#" class="link-block-68 w-inline-block" title="Cart" @click.prevent="toggleCart">
                      <img src="@/assets/images/icon_ cart.svg" loading="lazy" alt="" class="image-422">
                        <div class="div-block-1788">
                            <div class="text-block-859">{{ cartItemCount }}</div>
                        </div>
                    </a>
                    <a href="#" class="link-block-68 w-inline-block" title="Access menu" style="margin-left: 10px;" @click.prevent="openMenu=true;">
                        <div class="icon-28 w-icon-nav-menu"></div>
                    </a>
                    <div data-animation="over-right" :class="{'open-menu': openMenu}" style="display: none;" data-collapse="all" data-duration="400" data-easing="ease" data-easing2="ease" data-doc-height="1" role="banner" class="navbar w-nav">
                        <div class="menu-button w-nav-button w--open" aria-label="menu" role="button" tabindex="0" aria-controls="w-nav-overlay-0" aria-haspopup="menu" aria-expanded="true">
                            <div class="icon-28 w-icon-nav-menu"></div>
                        </div>
                        <div class="w-nav-overlay dropmenuopen" data-wf-ignore="" id="w-nav-overlay-0" >
                            <nav role="navigation" class="nav-menu w-nav-menu" style="transition: all, transform 400ms; transform: translateX(0px) translateY(0px); height: 4730px;" data-nav-menu-open="">
                                <div class="menu-top-box">
                                    <div class="burger-top">
                                        <div class="text-block-814">How can we help?</div><a href="#" @click.prevent="openMenu= false;" class="link-block-60 w-inline-block"><img src="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/6704b9c2fe63bd23cc0c22ff_icon_Close.svg" loading="lazy" alt=""></a>
                                    </div>
                                    <form action="/search" class="search w-form"><input class="search-input w-input" maxlength="256" name="query" placeholder="Search treatment or medication" type="search" id="search" required=""><input type="submit" class="search-button w-button" value=""></form>
                                </div>
                                <div class="most-popular-div">
                                    <div class="text-block-815">Most Popular</div>
                                    <router-link to="/store?category=Weight" class="most-pop-link w-inline-block">
                                        <div class="text-side">
                                            <div class="text-block-816">Weight Loss</div>
                                            <div class="text-block-853">Lose weight with science</div>
                                        </div>
                                        <div class="image-side-div weight"><img src="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/671a4d99b65b43e77ead546f_menu-images_pen.png" loading="lazy" sizes="100vw" srcset="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/671a4d99b65b43e77ead546f_menu-images_pen-p-500.png 500w, https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/671a4d99b65b43e77ead546f_menu-images_pen-p-800.png 800w, https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/671a4d99b65b43e77ead546f_menu-images_pen.png 1080w" alt=""></div>
                                    </router-link>
                                    <router-link to="/store?category=Longevity" class="most-pop-link w-inline-block">
                                        <div class="text-side">
                                            <div class="text-block-816">Longetivity</div>
                                            <div>Live healthier and longer</div>
                                        </div>
                                        <div class="image-side-div longevity"><img src="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/671a4d9918369340f6c635b8_menu-images_SemoVial.png" loading="lazy" sizes="100vw" srcset="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/671a4d9918369340f6c635b8_menu-images_SemoVial-p-500.png 500w, https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/671a4d9918369340f6c635b8_menu-images_SemoVial-p-800.png 800w, https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/671a4d9918369340f6c635b8_menu-images_SemoVial.png 1080w" alt=""></div>
                                    </router-link>
                                    <router-link to="/store?category=Mind" class="most-pop-link last w-inline-block">
                                        <div class="text-side">
                                            <div class="text-block-816">Brain Health</div>
                                            <div>Gain limitless focus</div>
                                        </div>
                                        <div class="image-side-div mind"><img src="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/671a4d9af6e6ac8939608691_menu-images_NAD.png" loading="lazy" sizes="100vw" srcset="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/671a4d9af6e6ac8939608691_menu-images_NAD-p-500.png 500w, https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/671a4d9af6e6ac8939608691_menu-images_NAD-p-800.png 800w, https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/671a4d9af6e6ac8939608691_menu-images_NAD.png 1080w" alt=""></div>
                                    </router-link>
                                </div>
                                <div class="div-block-1761">
                                    <div class="text-block-815">AI Enabled Health Optimization</div><a href="#" class="menu-category-link w-inline-block">
                                        <div>Build Your Daily Health Routine </div><img src="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/67199bb1e6abbbb5f2855bd8_icon_right.svg" loading="lazy" alt="" class="image-425">
                                    </a><a href="#" class="menu-category-link w-inline-block">
                                        <div>Instant answers to Health Questions</div><img src="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/67199bb1e6abbbb5f2855bd8_icon_right.svg" loading="lazy" alt="" class="image-425">
                                    </a><a href="#" class="menu-category-link w-inline-block">
                                        <div>Learn From Top Health Experts</div><img src="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/67199bb1e6abbbb5f2855bd8_icon_right.svg" loading="lazy" alt="" class="image-425">
                                    </a><a href="#" class="menu-category-link w-inline-block">
                                        <div>Download NewSelf Guides</div><img src="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/67199bb1e6abbbb5f2855bd8_icon_right.svg" loading="lazy" alt="" class="image-425">
                                    </a>
                                </div><router-link to="/login" class="nav-button w-button" v-if="!isLoggedin">Sign in</router-link>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';


export default {
  name: 'ProductPage',
  data() {
    return {
      lightboxOpen: false,
      product: null,
      currentImageIndex: 0,
      activeDropdown: null,
      error: null,
      isLoading: true,
      openDropdown: null,
      openMenu: false,
      baseUrl: process.env.VUE_APP_API_ENDPOINT
    };
  },
  computed: {
    ...mapGetters([
      'isCartOpen',
      'cartItemCount'
    ]),
    isLoggedin() {
        return this.$store.getters.isAuthenticated;
    },
  },
  methods: {
    ...mapActions([
      'setCartVisibility'
    ]),
    
    
    toggleCart() {
      this.setCartVisibility(!this.isCartOpen);
    },
   
    toggleDropdown(index) {
      this.openDropdown = this.openDropdown === index ? null : index;
    },

    logoutUser(){
       
            this.$axios.get(this.baseUrl + '/api/logout').then(response => {
                if (response.data.status == 'success') {
                    localStorage.removeItem('_ymain_key_');
                    window.location.reload();
                }
            }).catch(error => {
                console.log(error);
                localStorage.removeItem('_ymain_key_');
                window.location.reload();
            });
    },
    handleImageError(event) {
      // Replace broken images with a placeholder
      event.target.src = '/images/placeholder.jpg';
    }
  },
  created() {
    
  },
  
};
</script>
<style scoped>
.light-video {
  width: 100% !important;
  height: 100% !important;
}
.open-menu{
  display: block !important;
}
.div-block-1714 {
        margin-bottom: 10px;
    }
</style>